import { SystemSettingsService } from '@/services/systemSettings'

export default {
  methods: {
    async getSystemSetting (name, dataKey = null, validateEnabled = false) {
      try {
        const res = await SystemSettingsService.get(name)

        if (validateEnabled) {
          if (res.Enabled) {
            this[dataKey || name] = res.Value
          }
          return;
        }

        this[dataKey || name] = res.Value
      } catch (e) {
        console.log(e)
      }
    }
  }
}
